import { Injectable } from '@angular/core';
import { OccEndpointsService, TranslationService } from '@spartacus/core';
import { failStatus, StatusRequest, successStatus } from '../../../../../core/models/request-status.model';
import { catchError, map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { OptionsRequest } from '../../../../../core/models/others.model';
import { ContactForm, SubTopicRequest, TopicSendItem } from './contact-our-experts.model';

@Injectable({
  providedIn: 'root',
})
export class ContactOurExpertsConnector {
  constructor(
    private http: HttpClient,
    private occEndPointService: OccEndpointsService,
    private translationService: TranslationService,
  ) {}

  getSupportTopics(): Observable<OptionsRequest> {
    const url = this.occEndPointService.buildUrl('topic');

    return this.http.get(url).pipe(
      map((response: any) => {
        return {
          options: response,
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
          })),
        );
      }),
    );
  }

  getSubTopics(topicCode: string): Observable<SubTopicRequest> {
    const url = this.occEndPointService.buildUrl('subTopic', { urlParams: { topicCode } });
    // const subTopic1: SubTopic = {
    //   options: [
    //     { code: '10', label: 'Sub Topic 1' },
    //     { code: '20', label: 'Sub Topic 2' },
    //     { code: '30', label: 'Sub Topic 3' },
    //   ],
    // };

    // const subTopic2: SubTopic = {
    //   action: SUBTOPIC_ACTIONS.SHOW_FORM,
    // };

    // const subTopic3: SubTopic = {
    //   action: SUBTOPIC_ACTIONS.CONTENT,
    //   content: '<strong> Teste </strong>',
    // };

    return this.http.get(url).pipe(
      map((response: any) => {
        return {
          subTopic: response,
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
          })),
        );
      }),
    );
  }

  getOption(subTopicCode: string): Observable<SubTopicRequest> {
    const url = this.occEndPointService.buildUrl('option', { urlParams: { subTopicCode: subTopicCode } });

    return this.http.get(url).pipe(
      map((response: any) => {
        return {
          subTopic: response,
          ...successStatus,
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
          })),
        );
      }),
    );
  }

  submitContactForm(_user: ContactForm): Observable<StatusRequest> {
    const url = this.occEndPointService.buildUrl('contactForm', {
      queryParams: { 'sap-commerce-cloud-captcha-token': _user.token },
    });

    const user: TopicSendItem = {
      topicCode: _user.topic,
      optionCode: _user.subTopic,
      firstName: _user.firstName,
      lastName: _user.lastName,
      workEmail: _user.email,
      phoneNumber: _user.phoneNumber,
      extension: _user.extension,
      companyName: _user.companyName,
      businessType: _user.businessType,
      country: _user.country,
      region: _user.region,
      city: _user.city,
      zipcode: _user.zipCode,
      description: _user.info,
      marketingTerms: _user.optIn,
      policyTerms: _user.agreeWithPolicy,
    };

    return this.http.post(url, user).pipe(
      map(() => {
        return {
          ...successStatus,
          message: 'Form submitted successfully. We will contact you shortly.',
        };
      }),
      catchError(() => {
        return this.translationService.translate('generic.error').pipe(
          map(textError => ({
            message: textError,
            ...failStatus,
          })),
        );
      }),
    );
  }
}
